import Vue from 'vue'

export const DEF_GROUP = 'main'

export const notify = {
  success: (text, data) => {
    data = getSettings()
    Vue.notify({...data, text, type: 'success'})
  },
  warn: (text, data) => {
    data = getSettings()
    Vue.notify({...data, text, type: 'warn'})
  },
  error: (text, data) => {
    data = getSettings()
    Vue.notify({...data, text, type: 'error'})
  }
}

function getSettings (data) {
  if (!data) {
    data = {
      group: DEF_GROUP
    }
  }
  if (!data.group) {
    data.group = DEF_GROUP
  }
  return data
}



// WEBPACK FOOTER //
// ./scripts/src/shared/notifications.js